import { Markdown } from '@wair/markdown'
import { AnimatePresence, motion } from 'framer-motion'
import { Atom, ChevronDown, ChevronUp } from 'lucide-react'
import { memo, useState } from 'react'

interface ThinkingProps {
  content?: string
  duration?: number
  thinking?: boolean
}

const Thinking = memo<ThinkingProps>(({ content, duration, thinking }) => {
  const [showDetail, setShowDetail] = useState(true)

  // useEffect(() => {
  //   setShowDetail(!!thinking)
  // }, [thinking])

  if (!content) {
    return null
  }

  return (
    <>
      <div className="flex flex-col w-fit gap-4">
        <div
          className="cursor-pointer flex-1 flex gap-1 items-center justify-between text-[#1C1F23] font-medium"
          onClick={() => {
            setShowDetail(!showDetail)
          }}
        >
          {thinking ? (
            <img
              className="w-5 h-5"
              src="https://zdtc-cdn.wair.ac.cn/public/loadding.gif"
            />
          ) : (
            <Atom size={16} />
          )}
          <span>
            {thinking
              ? '深度思考中...'
              : !duration
                ? '已深度思考'
                : `已深度思考（用时 ${duration} 秒）`}
          </span>
          {showDetail ? <ChevronUp size={16} /> : <ChevronDown size={16} />}
        </div>
      </div>
      <AnimatePresence initial={false}>
        {showDetail && (
          <motion.div
            animate="open"
            exit="collapsed"
            initial="collapsed"
            style={{ overflow: 'hidden' }}
            transition={{
              duration: 0.2,
              ease: [0.4, 0, 0.2, 1], // 使用 ease-out 缓动函数
            }}
            variants={{
              collapsed: { height: 0, opacity: 0, width: 'auto' },
              open: { height: 'auto', opacity: 1, width: 'auto' },
            }}
          >
            <div className="relative pl-3">
              <div className="border-l-[#1C1F231A] h-[calc(100%_-_10px)] absolute mt-[5px] border-l-2 border-solid left-0 top-0"></div>
              <Markdown
                content={content}
                showAnimation={thinking}
                enableCitation={true}
                className="text-[#1C1F2399]"
              />
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </>
  )
})

export default Thinking
